module.exports = __webpack_public_path__ + "static/img/why-2.82c64764.png";